(() => {
  if (window.dabovVideoHeroInitialized) return;
  window.dabovVideoHeroInitialized = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const hydrate = (video, shouldPlay = true) => {
    if (!video || reducedMotion.matches) return;

    if (video.dataset.dabovHydrated !== 'true') {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.dabovHydrated = 'true';
      video.load();
    }

    if (shouldPlay) video.play().catch(() => {});
  };

  const schedulePriorityVideo = (video) => {
    const desktopViewport = window.matchMedia('(min-width: 750px)');
    if (!desktopViewport.matches && video.dataset.dabovMobileAutoplay !== 'true') {
      const startWhenDesktop = (event) => {
        if (!event.matches) return;
        desktopViewport.removeEventListener('change', startWhenDesktop);
        schedulePriorityVideo(video);
      };
      desktopViewport.addEventListener('change', startWhenDesktop);
      return;
    }

    const start = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => hydrate(video), { timeout: 1200 });
      } else {
        window.setTimeout(() => hydrate(video), 250);
      }
    };

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  };

  const initialize = (scope = document) => {
    if (reducedMotion.matches) return;

    scope.querySelectorAll('[data-dabov-priority-video]:not([data-dabov-observed])').forEach((video) => {
      video.dataset.dabovObserved = 'true';
      schedulePriorityVideo(video);
    });

    const lazyVideos = [...scope.querySelectorAll('[data-dabov-lazy-video]:not([data-dabov-observed])')];
    if (!lazyVideos.length) return;

    if (!('IntersectionObserver' in window)) {
      lazyVideos.forEach((video) => hydrate(video));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) hydrate(video);
          else if (video.dataset.dabovHydrated === 'true') video.pause();
        });
      },
      { rootMargin: '300px 0px', threshold: 0.01 },
    );

    lazyVideos.forEach((video) => {
      video.dataset.dabovObserved = 'true';
      observer.observe(video);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
